import { useMemo } from 'react';
import type { Middleware } from '@floating-ui/dom';
import { useTheme } from '@trinity/chat-components/components/Theme';

const DEFAULT_BASE_MODAL_Z_INDEX = 1300;
const CSS_VAR_POPPER_Z_INDEX = '--popper-z-index';

export const useZIndexMiddleware = (overrideZIndex?: number) => {
  const theme = useTheme();
  const baseModal = theme.zIndex?.baseModal ?? DEFAULT_BASE_MODAL_Z_INDEX;
  const zIndex = overrideZIndex ?? baseModal + 1;

  return useMemo(() => {
    const middleware: Middleware = {
      name: 'zIndexer',
      options: {
        zIndex,
      },
      fn: (data) => {
        data.elements.floating.style.zIndex = `var(${CSS_VAR_POPPER_Z_INDEX}, ${zIndex})`;
        return data;
      },
    };
    return middleware;
  }, [zIndex]);
};

export const useSameWidthMiddleware = () => {
  return useMemo(() => {
    const middleware: Middleware = {
      name: 'sameWidth',
      options: {
        sameWidth: true,
      },
      fn: (data) => {
        const refWidth = (data.elements.reference as HTMLDivElement).offsetWidth;
        data.elements.floating.style.width = `${refWidth}px`;
        return data;
      },
    };
    return middleware;
  }, []);
};